import type { WeaverApiTyped } from './types';

import './setup';
import { weaverApiRoot } from './root';

export const weaver = weaverApiRoot as WeaverApiTyped;
